import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    paper: {
      width: 496,
    },
    dialogTitle: {
      padding: 0,
    },
    dialogActions: {
      justifyContent: 'center',
      marginBottom: theme.spacing(5),
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(5, 10),
    },
    buttonClose: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
      padding: theme.spacing(1),
    },
    iconClose: {
      height: '11px',
      width: '11px',
    },
    title: {
      marginTop: theme.spacing(4),
      fontSize: theme.typography.pxToRem(24),
      lineHeight: theme.typography.pxToRem(32),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.primary.text,
      textAlign: 'center',
    },
    message: {
      marginTop: theme.spacing(3),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      color: theme.palette.primary.text,
      textAlign: 'center',
    },
  }),
  { name: 'GenericNotificationPopup' }
);
